import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}><path fill="#DF532D" fillRule="evenodd" d="M5.44 14.06a10.56 10.56 0 1121.12 0c0 3.57-2.16 6.56-4.5 8.9-.5.5-6.06 5.54-6.06 5.54s-5.14-4.65-6.68-6.25c-2.12-2.2-3.88-4.88-3.88-8.19zM16 17.81a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z" clipRule="evenodd" /></svg>);